// src/app/viaje/viajeTraslado/particular/components/particular-travels-table/actions/GmailAction.tsx
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import React, { FC } from 'react';

interface MailActionProps {
  emailAddress: string;
  subject?: string;
  body?: string;
  cc?: string;
  bcc?: string;
}
const MailAction: FC<MailActionProps> = ({
  emailAddress,
  subject,
  body,
  cc,
  bcc
}) => {
  const params = new URLSearchParams();
  if (subject) params.append('subject', subject);
  if (body) params.append('body', body);
  if (cc) params.append('cc', cc);
  if (bcc) params.append('bcc', bcc);

  const mailto = `mailto:${encodeURIComponent(emailAddress)}${
    params.toString() ? `?${params.toString()}` : ''
  }`;

  return (
    <a
      href={mailto}
      className="rounded-full "
      title="Enviar email LLT"
      style={{
        backgroundColor: '#008DA3',
        color: '#ffffff',
        width: '19px',
        height: '19px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #008DA3'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.color = '#008DA3';
        e.currentTarget.style.borderColor = '#ffffff';
        e.currentTarget.style.backgroundColor = '#ffffff';
        e.currentTarget.style.border = '1px solid #008DA3';
    }}
    onMouseLeave={(e) => {
        e.currentTarget.style.color = '#ffffff';
        e.currentTarget.style.borderColor = '#ffffff';
        e.currentTarget.style.backgroundColor = '#008DA3';
        e.currentTarget.style.border = '1px solid #008DA3';
      }}
    >
      <FontAwesomeIcon icon={faEnvelope} style={{ fontSize: '13px' }} />
    </a>
  );
};

export default MailAction;
